import React, { useState } from "react";
import { Spin, Icon } from "antd";
import styles from "./imageCard.scss";
import { getIconUrl } from "../../../../../services/asset";
import { UploadStatus } from "../../../../../models/enums";

interface ImageCardProps {
  className: string;
  disabled: boolean;
  draggable: boolean;
  imageUrl: string;
  index: number;
  onMove: (fromIndex: number, toIndex: number) => void;
  onPreview: (x: string) => void;
  onRemove: (index: number) => void;
  status: string;
}

const ImageCard = (props: ImageCardProps) => {
  const { className, status, imageUrl, onPreview } = props;
  const [error, setError] = useState(false);

  const handleError = () => {
    setError(true);
  };

  const handleDeleteClick = e => {
    const { index, onRemove } = props;
    onRemove(index);
    e.stopPropagation();
  };

  const renderImage = () => {
    const { imageUrl, status } = props;
    if (error || status === UploadStatus.error) {
      return (
        <div className={styles.error}>
          {"Greška"}
        </div>
      );
    }
    return <img alt={imageUrl} src={imageUrl} onErrorCapture={handleError} />;
  };

  const renderHoverMenu = () => {
    const { disabled } = props;
    if (disabled) {
      return null;
    }

    return (
      <div className={styles.hoverMenu}>
        <img
          role="presentation"
          alt="delete"
          src={getIconUrl("delete-icon.svg")}
          className={styles.deleteButton}
          onClick={handleDeleteClick}
        />
      </div>
    );
  };

  return (
    <span
      className={`${styles.imageCard} ${className}`}
      tabIndex={-1}
      role="button"
      onClick={() => error || status === UploadStatus.error ? null : onPreview(imageUrl)}
    >
      {status !== UploadStatus.uploading ? (
        <React.Fragment>
          {renderImage()}
          {renderHoverMenu()}
        </React.Fragment>
      ) : (
        <div className={styles.loadingCard}>
          <Spin indicator={<Icon type="loading-3-quarters" spin />} />
        </div>
      )}
    </span>
  );
};

ImageCard.defaultProps = {
  className: "",
  disabled: false,
  imageUrl: null
};

export default ImageCard;



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/SinglePhoto/ImageCard/index.tsx